@if (showButton()) {
  <button
    data-test="sync-from-fms-button"
    mat-stroked-button
    class="sync-from-fms-button"
    [disabled]="isSyncing()"
    [matTooltip]="'shared.diseaseTable.syncFromFmsTooltip' | translate"
    (click)="onSyncFms()"
  >
    <span class="sync-from-fms-button__content">
      @if (isSyncing()) {
        <mat-spinner diameter="18" strokeWidth="3" />
      } @else {
        <img
          ngSrc="../../../../../assets/icons/sync-from-fms.svg"
          alt=""
          aria-hidden="true"
          class="sync-from-fms-button__icon"
          height="18"
          width="22"
        />
      }
      <span class="sync-from-fms-button__text">{{ 'shared.diseaseTable.syncFromFms' | translate }}</span>
    </span>
  </button>
}
